import { ApiBase, HttpMethod } from "../../core/api-base";
import type * as z from "zod";
import { FollowUserBody, UnfollowUserParams } from "../../api/generated/users.zod";

export class UserFollowApi extends ApiBase {
    public static follow(targetUserId: z.infer<typeof FollowUserBody>["user_id"]): Promise<Response> {
        return super.apiRequestWithErrorHandling(
            "/api/v1/users/follow",
            HttpMethod.Post,
            { user_id: targetUserId },
            { fallbackMessage: "Failed to follow user" },
        );
    }

    public static unfollow(targetUserId: z.infer<typeof UnfollowUserParams>["user_id"]): Promise<Response> {
        return super.apiRequestWithErrorHandling(`/api/v1/users/follow/${targetUserId}`, HttpMethod.Delete, null, {
            fallbackMessage: "Failed to unfollow user",
        });
    }
}
